import React from 'react';
import { getFieldSetting } from '../helpers/HelperFunctions.js';

const RadioButtonGroupInput = (props) => {
    const { name, value, values, placeholders, disabled } = props;

    const options = values?.data?.filter(item => !item.hidden) ?? [];

    const selectHandle = (item) => {
        if (disabled || item.value === value || !props.onChange) return;
        props.onChange({
            target: {
                name: name,
                value: item.value
            }
        });
    }

    return (<div className={"radio-button-group" + (disabled ? " disabled" : "")}>
        {options.map(item => {
            const description = getFieldSetting(placeholders, item.value);
            // варіант — це заголовок разом з описом: на десктопі вони стають однією карткою,
            // тому вибір вішається на обгортку, а не тільки на рядок із заголовком
            return <div key={item.value} className={'radio-button-group-option' + (item.value === value ? ' selected' : '')}
                onClick={() => selectHandle(item)}>
                <div className="radio-button-group-item">
                    <span>{item.label}</span>
                    <div className={'radio' + (item.value === value ? ' checked' : '')} />
                </div>
                {description && <p className="radio-button-group-description">{description}</p>}
            </div>
        })}
    </div>);
}

export default RadioButtonGroupInput;
